import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { WelkomComponent } from './welkom/welkom.component';
import { DorpelComponent } from './dorpel/dorpel.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { RedirectComponent } from './redirect/redirect.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { NeutenComponent } from './neuten/neuten.component';
import { SluitpotComponent } from './sluitpot/sluitpot.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { DorpelPageComponent } from './dorpel-page/dorpel-page.component';
import { NeutComponent } from './neuten/neut/neut.component';
import { NO_ERRORS_SCHEMA } from '@angular/core';
import { OverzichtComponent } from './overzicht/overzicht.component';
import { DealersComponent } from './dealers/dealers.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CanvasComponent } from './dorpel/canvas/canvas.component';
import { DaagmaatComponent } from './neuten/daagmaat/daagmaat.component';
import { BewerkingenHorizComponent } from './bewerkingen-horiz/bewerkingen-horiz.component';
import { BewerkingenPillComponent } from './bewerkingen-horiz/bewerkingen-pill/bewerkingen-pill.component';
import { FileValueAccessorDirective } from './shared/file-value-accessor.directive';
import { FileFormatValidator } from './shared/file-format-validator';
import { ResizeListener } from './shared/resize-listener';
import { LuvemaLandingComponent } from './landing-pages/luvema-landing.component';
import { IntegerOnlyDirective } from './shared/integer-only.directive';

@NgModule({
   declarations: [
      AppComponent,
      WelkomComponent,
      DorpelPageComponent,
      DorpelComponent,
      HeaderComponent,
      FooterComponent,
      RedirectComponent,
      NeutenComponent,
      NeutComponent,
      SluitpotComponent,
      TooltipComponent,
      OverzichtComponent,
      DealersComponent,
      CanvasComponent,
      DaagmaatComponent,
      LuvemaLandingComponent,
      BewerkingenHorizComponent,
      BewerkingenPillComponent,
      FileValueAccessorDirective,
      IntegerOnlyDirective,
      FileFormatValidator,
      ResizeListener
   ],
   imports: [
      BrowserModule,
      AppRoutingModule,
      NgbModule,
      CoreModule,
      SharedModule,
      NgxSpinnerModule,
      BrowserAnimationsModule
   ],
   schemas: [
      NO_ERRORS_SCHEMA
   ],
   providers: [],
   bootstrap: [
      AppComponent
   ]
})
export class AppModule { }
